//@ts-nocheck
import React from 'react';
import Modal from 'react-modal';
import Dropzone from 'react-dropzone';

import * as mux from './mux';

import ProgressBar from './ProgressBar';
import { VideoThumbnail } from '@client/new/pages/influencer/videos/components/VideoPanel/VideoThumbnail';
import { TextField } from '@client/new/components/basic';
import { PrimaryButton } from '@client/new/components/button';
import { mixTrack } from '@services/mixpanel';
import videoUploadIcon from '/static/images/video-upload.svg';
import cloudUploadIcon from '/static/images/icon-upload-cloud.svg';
import videoLibraryHeaderIcon from '/static/images/video-library-header.svg';

class VideoUploadModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: {},
      fileDropped: false,
      inProgress: false,
      fileUploaded: false,
      titleSaved: false,
      uploadProgress: 0,
      signedUrl: '',
      title: '',
      thumbnails: [],
      muxUploadInstance: null,
      duration: null,
      chosenThumbnail: null,
    };
    this.onOpenClick = this.onOpenClick.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.onUploadError = this.onUploadError.bind(this);
    this.onUploadSuccess = this.onUploadSuccess.bind(this);
    this.onUploadProgress = this.onUploadProgress.bind(this);
    this.renderModalContent = this.renderModalContent.bind(this);
    this.startUpload = this.startUpload.bind(this);
    this.cancelUpload = this.cancelUpload.bind(this);
    this.onModalClose = this.onModalClose.bind(this);
    this.titleChanged = this.titleChanged.bind(this);
    this.checkVideoMetadata = this.checkVideoMetadata.bind(this);
    this.abortUpload = this.abortUpload.bind(this);
    this.setDuration = this.setDuration.bind(this);
  }

  componentDidMount() {
    window.addEventListener('beforeunload', (event) => {
      if (this.state.inProgress) {
        if (typeof event == 'undefined') {
          event = window.event;
        }
        event.returnValue = '';
        return '';
      }
    });
  }

  setDuration(metadata) {
    if (this.state.duration === metadata.duration) {
      return;
    }
    this.setState({ duration: metadata.duration });
  }

  async onModalClose(data) {
    const { inProgress, fileUploaded } = this.state;
    if (inProgress) {
      return;
    }
    this.props.onClose(data);
    if (fileUploaded) {
      await this.props.refreshLibrary();
    }
    this.setState({
      inProgress: false,
      fileDropped: false,
      fileUploaded: false,
      signedUrl: null,
      uploadProgress: 0,
      file: {},
    });
  }

  onOpenClick() {
    this.refs.dropzone.open();
  }

  checkVideoMetadata(file) {
    return new Promise((resolve, reject) => {
      try {
        let video = document.createElement('video');
        video.preload = 'metadata';

        video.onloadedmetadata = function () {
          resolve(this);
        };

        video.onerror = function () {
          reject('Invalid video. Please select a video file.');
        };

        video.src = window.URL.createObjectURL(file);
        return video;
      } catch (e) {
        reject(e);
      }
    });
  }

  abortUpload() {
    if (this.state.muxUploadInstance) {
      this.state.muxUploadInstance.abort();
      this.setState({
        uploadProgress: 0,
        inProgress: false,
        fileDropped: false,
        fileUploaded: false,
        signedUrl: null,
        title: '',
        titleSaved: false,
      });
    }
    return;
  }

  onUploadProgress(event) {
    this.setState({
      uploadProgress:
        event.detail > this.state.uploadProgress
          ? event.detail
          : this.state.uploadProgress,
    });
  }

  onUploadSuccess() {
    this.setState({
      uploadProgress: 0,
      inProgress: false,
      fileDropped: false,
      fileUploaded: true,
      signedUrl: null,
    });
  }

  onUploadError() {
    throw new Error('Error while uploading a video file');
  }

  async startUpload() {
    const { file, title, chosenThumbnail } = this.state;
    const thumbnail = this.state.thumbnails.find(
      (t) => t.index === chosenThumbnail,
    );
    this.setState({
      fileDropped: false,
      inProgress: true,
    });
    try {
      const data = await mux.generateMuxSignedUrl({
        influencerId: this.props.influencerId,
        fileSize: file.size,
        title,
        thumbnailPosition:
          thumbnail &&
          (thumbnail.position !== null || thumbnail.position !== undefined)
            ? thumbnail.position
            : null,
      });
      const resp = mux.upload({
        file: file,
        url: data && data.signedURL,
        chunkSize: 5120,
      });
      this.setState({ muxUploadInstance: resp });

      this.state.muxUploadInstance.on('progress', (p) =>
        this.onUploadProgress(p),
      );
      this.state.muxUploadInstance.on('success', (s) => {
        this.onUploadSuccess(s);
        mixTrack({
          type: 'Video Uploaded',
          payload: {
            'Upload Location': 'Video Library',
            'Video Type': 'Long',
          },
        });
      });
      this.state.muxUploadInstance.on('error', (e) => this.onUploadError(e));
    } catch (err) {
      this.props.onClose({ error: true });
      this.setState({
        inProgress: false,
        fileDropped: false,
        fileUploaded: false,
        signedUrl: null,
        uploadProgress: 0,
        file: {},
      });
    }
  }

  cancelUpload() {
    this.setState({
      inProgress: false,
      fileDropped: false,
      signedUrl: null,
      uploadProgress: 0,
      file: {},
    });
  }

  titleChanged(event) {
    this.setState({
      title: event.target.value,
    });
  }

  async onDrop(fileDrop) {
    const file = fileDrop && fileDrop.length && fileDrop[0];

    let duration = 1;
    try {
      const metadata = await this.checkVideoMetadata(file);
      duration = metadata.duration;
    } catch (e) {
      console.error('Error in onDrop(fileDrop)', e);
      return this.onModalClose({
        error: 'Not able to fetch duration from the video.',
      });
    }

    if (duration && duration < 45) {
      return this.onModalClose({
        error: 'You can upload only videos longer than 45 seconds.',
      });
    }

    this.setState({
      duration,
      file,
      fileDropped: true,
    });
  }

  renderModalContent() {
    const {
      uploadProgress,
      file,
      inProgress,
      fileDropped,
      fileUploaded,
      titleSaved,
    } = this.state;
    const browseLink = inProgress ? (
      ''
    ) : (
      <div>
        <img
          src={videoUploadIcon}
          style={{ height: '100px', margin: 'auto', marginTop: '50px' }}
        ></img>
        <h3>Upload your video</h3>
        <p>
          Drag & drop or{' '}
          <a onClick={this.onOpenClick} className="actionLink mark">
            browse
          </a>{' '}
          your video here
        </p>
      </div>
    );

    if (!inProgress && !fileDropped && !fileUploaded) {
      return (
        <Dropzone
          ref="dropzone"
          onDrop={this.onDrop}
          accept="video/*"
          className="dropzone"
          activeClassName="dropzone-active"
          disableClick={true}
          style={{ height: '100%', width: '100%' }}
        >
          <span className={`video-library-upload-title`}>{browseLink}</span>
        </Dropzone>
      );
    }
    if (fileDropped && !titleSaved) {
      return (
        <div
          style={{
            width: '100%',
            height: '100%',
            marginBottom: '-20px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <video
            controls
            width="600"
            height="330"
            style={{
              width: 600,
              height: 330,
              outline: 'none',
              marginBottom: '10px',
              borderRadius: '5px',
            }}
            src={file.preview}
          />
          <div className="flex mt-8 px-5 w-full gap-5">
            <TextField
              value={this.state.title}
              onChange={this.titleChanged}
              InputProps={{
                placeholder: 'Enter video title',
              }}
            ></TextField>
            <PrimaryButton
              onClick={() => this.setState({ titleSaved: true })}
              disabled={!this.state.title}
            >
              Save
            </PrimaryButton>
          </div>
        </div>
      );
    }
    if (fileDropped && titleSaved) {
      const positions = new Array(8)
        .fill()
        .map((_e, i) => i * Math.floor(this.state.duration / 7));
      const thumbnails = [...positions].map((value, i) => (
        <div
          className="video-thumbnail-preview cursor-pointer hover:border border-black"
          key={i}
          onClick={() => this.setState({ chosenThumbnail: i })}
        >
          <VideoThumbnail
            videoUrl={file.preview}
            thumbnailHandler={(t) =>
              this.setState({
                thumbnails: [
                  ...this.state.thumbnails,
                  { index: i, data: t, position: value },
                ],
              })
            }
            snapshotAtTime={value}
          />
        </div>
      ));
      const thumbnail =
        this.state.chosenThumbnail !== null
          ? this.state.thumbnails.find(
              (t) => t.index === this.state.chosenThumbnail,
            )
          : this.state.thumbnails &&
            this.state.thumbnails.length &&
            this.state.thumbnails[0];

      return (
        <div
          style={{
            width: '100%',
            height: '100%',
            marginBottom: '-20px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <img
            src={thumbnail?.data?.src || ''}
            style={{
              width: '600px',
              height: '330px',
              borderRadius: '5px',
              objectFit: 'contain',
            }}
          />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              fontSize: '16px',
              fontWeight: 600,
              alignItems: 'center',
              width: '100%',
              padding: '7px 15px 0 15px',
            }}
          >
            <div
              style={{ display: 'flex', flexDirection: 'row', width: '100%' }}
            >
              <img
                src={cloudUploadIcon}
                style={{
                  height: '14px',
                  width: '14px',
                  margin: '5px',
                }}
              ></img>
              <span style={{ margin: 'auto 5px' }}>{this.state.title}</span>
            </div>
            <div className="flex justify-between w-full">
              <p
                style={{
                  fontWeight: 400,
                  color: '#8F9BB3',
                  margin: '0',
                  textAlign: 'left',
                  fontSize: '14px',
                  paddingLeft: '30px',
                }}
              >
                Choose video thumbnail
              </p>
              <PrimaryButton onClick={this.startUpload}>Upload</PrimaryButton>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              marginTop: '8px',
              maxHeight: '50px',
            }}
          >
            {thumbnails}
          </div>
        </div>
      );
    }
    if (inProgress) {
      return (
        <div
          style={{
            width: '100%',
            height: '100%',
            marginBottom: '-20px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <video
            controls
            width="600"
            height="330"
            style={{
              outline: 'none',
              borderRadius: '5px',
              width: 600,
              height: 330,
            }}
            autoPlay
          >
            <source src={file && file.preview} type="video/mp4" />
          </video>
          <ProgressBar
            key={0}
            title={this.state.title}
            completed={uploadProgress}
            cancelUpload={this.abortUpload}
          />
        </div>
      );
    }
    if (fileUploaded) {
      setTimeout(() => this.onModalClose(), 2000);
      return (
        <div
          style={{
            width: '100%',
            height: '100%',
            marginBottom: '-20px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <video
            controls
            width="600"
            height="330"
            style={{
              outline: 'none',
              borderRadius: '5px',
              width: 600,
              height: 330,
            }}
          >
            <source src={file && file.preview} type="video/mp4" />
          </video>
          <span
            style={{
              color: '#101426',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              marginTop: '58px',
            }}
          >
            &#9989;
          </span>
        </div>
      );
    }
  }

  render() {
    return (
      <Modal
        isOpen={this.props.isOpen}
        onRequestClose={this.onModalClose}
        appElement={document.getElementById('app')}
        contentLabel={'Add To Library'}
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, .6)',
            zIndex: 99999,
            textAlign: 'center',
          },
          content: {
            alignItems: 'center',
            background: '#FDFEFE',
            margin: 'auto',
            maxWidth: '640px',
            maxHeight: '525px',
            borderRadius: '10px',
            border: 0,
            zIndex: 99999,
            padding: 0,
            WebkitOverflowScrolling: 'touch',
            display: 'grid',
            overflow: 'hidden',
            gridTemplateColumns: '100%',
            gridTemplateRows: '10% 90%',
          },
        }}
      >
        <div style={{ display: 'flex', margin: 'auto 40px' }}>
          <img src={videoLibraryHeaderIcon} style={{ height: '26px' }}></img>
          <span
            style={{
              fontWeight: 600,
              color: '#101426',
              fontSize: '18px',
              margin: '0 10px',
            }}
          >
            Upload a video
          </span>
        </div>
        {this.renderModalContent()}
        <a
          href="#"
          onClick={this.onModalClose}
          className="video-library-close"
        />
      </Modal>
    );
  }
}

export default VideoUploadModal;
